import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { Link } from 'react-router'
import { getI18n } from 'client/i18n'
import EditPart from 'components/edit_part'
import StandardEditPart from 'components/standard_edit_part'
import EmptyEditPart from 'components/empty_edit_part'
import Cover from 'components/cover'
import styles from './edit_main.less'
import { glimpseRoute } from 'lib/route_utils'
import { formatMoney, formatDateShort } from 'client/griffin'

const MAX_DESCRIPTION_ROWS = 5
const i18n = getI18n('components/edit_glimpse/edit_main')

class EditMain extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    backgroundImage: PropTypes.string,
    gradientColor: PropTypes.string,
    backgroundPan: PropTypes.number,
    goal: PropTypes.number,
    endDate: PropTypes.instanceOf(Date),
    ended: PropTypes.bool,
    description: PropTypes.string,
    contribPrefs: PropTypes.string,
    tracking: PropTypes.string,
    currency: PropTypes.string,
    showDelete: PropTypes.bool,
    location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onReopen: PropTypes.func,
    isAndroid: PropTypes.bool,
  }

  render() {
    const editRoute = glimpseRoute.bind(undefined, 'edit')
    const goalFormatted =
      this.props.goal &&
      formatMoney(this.props.currency, this.props.goal, {
        removeTrailingZeros: true,
      })

    return (
      <div>
        {this.props.ended && (
          <div styleName="ended-title">
            {i18n('ended', {
              endDate: formatDateShort(this.props.endDate),
            })}
          </div>
        )}
        <EditPart
          targetLocation={editRoute('name')}
          editName="poolName"
          labelName={this.props.title} // label for screen reader
        >
          <div styleName="title">{this.props.title}</div>
        </EditPart>
        {!this.props.isAndroid && (
          <EditPart
            targetLocation={editRoute('cover')}
            editName="cover"
            editButtonDisplay="bottom"
            labelName={i18n('goal_cover')}
          >
            <div styleName="goal-cover-title">{i18n('goal_cover')}</div>
            <Cover
              backgroundImage={this.props.backgroundImage}
              backgroundPan={this.props.backgroundPan}
              gradientColor={this.props.gradientColor}
              showHeader={false}
              suppressPrompt={true}
            />
          </EditPart>
        )}
        {this.props.goal ? (
          <StandardEditPart
            targetLocation={editRoute('amount')}
            title={i18n('goal_amount')}
            value={goalFormatted}
            key="goal_amount"
            editName="goalAmount"
          />
        ) : (
          <EmptyEditPart
            title={i18n('goal_amount')}
            description={i18n('add_goal_amount')}
            buttonTitle={i18n('add_goal_amount_button')}
            targetLocation={editRoute('amount')}
            key="empty_goal_amount"
            editName="goalAmount"
          />
        )}
        {(() => {
          if (this.props.endDate) {
            if (!this.props.ended) {
              return (
                <StandardEditPart
                  targetLocation={editRoute('end_date')}
                  title={i18n('ends_on')}
                  value={formatDateShort(this.props.endDate)}
                  key="ends_on"
                />
              )
            }
            return (
              <StandardEditPart
                editButtonDisplay="hide"
                title={i18n('ends_on')}
                value={i18n('ended', {
                  endDate: formatDateShort(this.props.endDate),
                })}
                description={i18n('pool_closed')}
                key="ended_ends_on"
                editName="endDate"
              />
            )
          }
          return (
            <EmptyEditPart
              title={i18n('ends_on')}
              description={i18n('add_ends_on')}
              buttonTitle={i18n('add_ends_on_button')}
              targetLocation={editRoute('end_date')}
              key="empty_ends_on"
              editName="endDate"
            />
          )
        })()}
        {this.props.description ? (
          <StandardEditPart
            targetLocation={editRoute('description')}
            title={i18n('description')}
            value={this.props.description}
            maxRows={MAX_DESCRIPTION_ROWS}
            key="description"
            editName="description"
          />
        ) : (
          <EmptyEditPart
            title={i18n('description')}
            description={i18n('add_description')}
            buttonTitle={i18n('add_description_button')}
            targetLocation={editRoute('description')}
            key="empty_description"
            editName="description"
          />
        )}
        <StandardEditPart
          targetLocation={editRoute('contribution')}
          title={i18n('contrib_pref')}
          value={this.props.contribPrefs}
          editName="contribPref"
        />
        <StandardEditPart
          targetLocation={editRoute('tracking')}
          title={i18n('public_tracking')}
          value={this.props.tracking}
          editName="publicTracking"
        />
        {this.props.showDelete && (
          <Link
            styleName="delete-link"
            data-nemo="deletePool"
            to={editRoute('delete')}
          >
            {i18n('delete')}
          </Link>
        )}
      </div>
    )
  }
}

export default cssModules(EditMain, styles)
